// @flow

const React = require('react');
const PropTypes = require('prop-types');

type ConfigProviderProps = {
  config: {},
  children: React.Node,
};

class ConfigProvider extends React.Component<ConfigProviderProps> {
  static childContextTypes = {
    config: PropTypes.object.isRequired,
  };

  getChildContext() {
    return {
      config: this.props.config,
    };
  }

  render() {
    return this.props.children;
  }
}

export default ConfigProvider;
